<template>
  <v-col>
    <v-row>
      <v-col>
        <p class="text-h5 text-no-wrap">Client</p>
      </v-col>
    </v-row>
    <v-row>
      <v-col align-self="center">
        <p class="text-caption">Name</p>
        <v-skeleton-loader
            class="car-card-title-skeleton-loader"
            type="text"
        />
      </v-col>
      <v-col align-self="center">
        <p class="text-caption">Username</p>
        <v-skeleton-loader
            class="car-card-title-skeleton-loader"
            type="text"
        />
      </v-col>
      <v-col align-self="center">
        <p class="text-caption">Default currency</p>
        <v-skeleton-loader
            class="car-card-title-skeleton-loader"
            type="text"
        />
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import {defineComponent} from 'vue'

export default defineComponent({
  name: "AccountClientInfoSkeleton"
})
</script>

<style scoped>
::v-deep .car-card-title-skeleton-loader > * {
  margin-inline-start: 0;
}
</style>